"use client";
import PageContainer from "@/app/admin/_common/PageContainer";
import { useLinkDetailModel } from "./linkDetailPageModel";
import LinkDetailHeader from "./_cmp/LinkDetailHeader";
import LinkStatTiles from "./_cmp/LinkStatTiles";
import LinkDetailsForm from "./_cmp/LinkDetailsForm";
import LinkSignupsTable from "./_cmp/LinkSignupsTable";
import LinkDetailSkeleton from "./_cmp/LinkDetailSkeleton";

export default function LinkDetailPage() {
  const { link, preview, isLoading, refetch, handleDelete } = useLinkDetailModel();

  return (
    <PageContainer flush>
      <div className="flex h-full w-full flex-col">
        <LinkDetailHeader link={link} onDelete={handleDelete} />

        <div className="min-h-0 flex-1 overflow-y-auto p-5">
          <div className="mx-auto w-full max-w-[920px] pb-12">
            {isLoading || !link ? (
              <LinkDetailSkeleton />
            ) : (
              <div className="flex flex-col gap-12">
                <LinkStatTiles link={link} />

                <LinkDetailsForm
                  key={link.id}
                  link={link}
                  preview={preview}
                  onSaved={refetch}
                />

                <div className="flex flex-col gap-6">
                  <div className="grid gap-1">
                    <div className="text-[16px] font-semibold text-foreground">Signups</div>
                    <div className="text-[12.5px] text-muted-foreground">
                      Guests who joined the waitlist after following this link.
                    </div>
                  </div>
                  <LinkSignupsTable guests={link.signups?.guests ?? []} onGuestSaved={refetch} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </PageContainer>
  );
}
